<template>
	<v-dialog v-model="show" width="70%" @click:outside="$emit('close')" scrollable>
		<v-card>
			<v-card-title class="title primary--text mb-2 secondary">
				<v-icon class="mr-3" color="primary">mdi-email-edit-outline</v-icon>
				<translate>Send Email</translate>
				<span class="mx-1">-</span>
				{{patient.name}}
			</v-card-title>
			<v-card-text>
				<v-form>
					<v-row no-gutters>
						<v-col cols="12" sm="12">
							<v-text-field class="mt-2" v-model="subject" :label="$gettext('Subject')" outlined />
						</v-col>
						<v-col cols="12" sm="12">
							<v-textarea auto-grow outlined :label="$gettext('Body')" v-model="body"></v-textarea>
						</v-col>
						<v-col cols="12" sm="12">
							<v-text-field v-model="email" :label="$gettext('Patient\'s Email')" outlined hide-details />
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary darken-1" :loading="loading" text @click="sendEmail" :disabled="!$store.getters.hasAnyModule">
					<translate>Send</translate>
				</v-btn>
				<v-btn color="primary darken-1" text @click="$emit('close')">
					<translate key="close">Close</translate>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios";

export default {
	name: "SendMonitoringLink",
	props: ["patient", "show"],
	data: () => ({
		subject: "",
		body: "",
		email: "",
		loading: false
	}),
	methods: {
		sendEmail() {
			this.loading = true;
			const formData = new FormData();
			formData.append("email", this.email);
			formData.append("subject", this.subject);
			formData.append("body", this.body);
			axios
				.post("/patient/" + this.patient.id + "/send_monitoring", formData)
				.then(response => {
					console.log(response.data);
					if (response.data.result == "sent") this.$emit("close");
					this.loading = false;
				})
				.catch(error => {
					console.log(error);
					this.loading = false;
				});
		}
	},
	computed: {
		monitoringLink() {
			return (
				"app.naltio.com/monitoring/" +
				this.patient.id +
				"?key=" +
				this.patient.monitoring_key
			);
		},
		bodyString() {
			return (
				"Para começar a fazer registos dos seus sinais e sintomas, p.f. click no link abaixo. Depois siga os seguintes passos:  \r\n\r\n" +
				"1. Clicar em “Novo Registo”\r\n" +
				"2. Ajustar o dia e hora se necessário (nota: se o valor que vai introduzir corresponder ao dia e hora que já aparecem, não necessita alterar nada).\r\n" +
				"3. Clicar no número de bolas (de 1 a 10) em função da intensidade sentida: sendo 1 - valor mínimo e 10 - valor máximo\r\n" +
				"4. Clicar em “Criar”\r\n\r\n" +
				"Deve repetir estes passos para cada sinal/sintoma incluídos.\r\n\r\n" +
				"Por favor, faça um registo pelo menos 1 vez por dia, sendo possível e desejável fazer mais do que uma vez por dia.\r\n\r\n" +
				"Clicar neste link para começar: " +
				"[link]\r\n\r\n" +
				"Atentamente,\r\n" +
				"[name]"
			);
		}
	},
	watch: {
		show(value) {
			if (value) {
				this.subject =
					this.$gettext("Monitoring your signs and symptoms") +
					" - " +
					this.$store.getters.spaceName;
				this.body = this.$store.getters.userMonitoringEmailBody
					.replace(/\[link\]/, this.monitoringLink)
					.replace(/\[name\]/, this.$store.getters.userName);
				this.email = this.patient.email;
			}
		}
	}
};
</script>